import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function LoginDiscord() {
  const navigate = useNavigate();

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const user = query.get("user");

    if (user) {
      const userData = JSON.parse(decodeURIComponent(user));
      console.log(userData);
      navigate("/dashboard");
    } else {
      navigate("/");
    }
  }, [navigate]);

  return <p>A iniciar sessão, aguarde...</p>;
}

export default LoginDiscord;
